import { FC } from 'react';

import Section from 'components/Section';
import DateRangePicker from 'components/DateRangePicker';

const PackageDateEditMainDates: FC = () => (
  <Section title="Datos" id="dates">
    <DateRangePicker name="dates" />
  </Section>
);

export default PackageDateEditMainDates;
